import request from "./axios";
import { BASEAPI } from "./api";

export function getBanner() {
  return request({
    url: BASEAPI + "/api/Advertisement/Query",
    method: "get",
    params: {
      page: 1,
      pageSize: 10,
      status: 1,
    },
  });
}

// export function getMeetingList(params) {
//   let url = BASEAPI + "/api/Out/YiDaoH5Query";
//   switch (params.type) {
//     case "live":
//       url =
//         BASEAPI +
//         `/api/Out/YiDaoH5Query?page=${params.page}&pageSize=${params.pageSize}&status=1&status=2`;
//       break;
//     case "end":
//       url =
//         BASEAPI +
//         `/api/Out/YiDaoH5Query?page=${params.page}&pageSize=${params.pageSize}&status=4&status=5`;
//       break;
//     case "back":
//       url =
//         BASEAPI +
//         `/api/Out/YiDaoH5Query?page=${params.page}&pageSize=${params.pageSize}&status=3`;
//       break;
//     case "wait":
//       url =
//         BASEAPI +
//         `/api/Out/YiDaoH5Query?page=${params.page}&pageSize=${params.pageSize}&status=0`;
//       break;
//     default:
//       url =
//         BASEAPI +
//         `/api/Out/YiDaoH5Query?page=${params.page}&pageSize=${params.pageSize}`;
//       break;
//   }

//   return request({
//     url: url,
//     method: "get",
//   });
// }

export function getMeetingList(params) {
  // let status = obj.status.map((item) => {
  //   return `Status=${item}`;
  // });
  var status = Object.keys(params)
    .map(function (key) {
      if (params[key] instanceof Array) {
        return params[key]
          .map(function (fkey) {
            // debugger;
            return encodeURIComponent(key) + "=" + encodeURIComponent(fkey);
          })
          .join("&");
      } else {
        return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
      }
    })
    .join("&");
  return request({
    url: `${BASEAPI}/api/Out/FullData?${status}`,
    method: "get",
  });
}
export function addClickCount(id) {
  return request({
    url: BASEAPI + "/api/Advertisement/IncreaseClickCOunt",
    method: "get",
    params: {
      id,
    },
  });
}
